export default {
    getContactsIcon(icon) {
        return {}[icon];
    }
}